.popup {
  z-index: 1300;
  max-height: 80%;
}

.spinner {
  margin: 16px;
}

.failed {
  padding: var(--tuna-spacing-2);
  color: var(--tuna-content-primary);
}
